// src/blog/pages/BlogAdminDashboard.js

import React, { useEffect, useState } from 'react';
import { Link, useNavigate }    from 'react-router-dom';
import ReactQuill               from 'react-quill';
import 'react-quill/dist/quill.core.css';
import 'react-quill/dist/quill.snow.css';

import '../../App.css';
import './BlogAdminDashboard.css';
import axios from 'axios';

// ——— Make these available everywhere ———
const apiUrl        = process.env.REACT_APP_API_URL;        // e.g. "http://localhost:5000/api"
const uploadsOrigin = process.env.REACT_APP_FOR_UPLOADS_URL; // e.g. "http://localhost:5000"

// ——— Quill toolbar & handlers ———
const toolbarOptions = [
  [{ header: [1, 2, false] }],
  ['bold','italic','underline','strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  ['link','image'],
  ['clean'],
];

function imageHandler() {
  // 1) create and open file picker
  const input = document.createElement('input');
  input.setAttribute('type',   'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  // 2) when a file is chosen…
  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;

    // 3) build FormData & upload
    const form = new FormData();
    form.append('file', file);    // ← matches upload.single('file')

    try {
      // POST to your generic upload route you added:
      // router.post('/', upload.single('file'), …) in documentUploads.js
      const res = await axios.post(
        `${apiUrl}/uploads`,
        form,
        { headers: { 'Content-Type': 'multipart/form-data' }}
      );
      // res.data.url is something like "/uploads/documents/12345-foo.png"
      const imageUrl = `${uploadsOrigin}${res.data.url}`;

      // 4) prompt for optional click‑through link
      const linkUrl = window.prompt('Enter click‑through URL (optional):');

      // 5) insert into Quill
      const quill = this.quill;
      const range = quill.getSelection(true);
      const html  = linkUrl
        ? `<a href="${linkUrl}" target="_blank" rel="noopener noreferrer">
             <img src="${imageUrl}" style="max-width:100%;" />
           </a>`
        : `<img src="${imageUrl}" style="max-width:100%;" />`;

      quill.clipboard.dangerouslyPasteHTML(range.index, html);
      quill.setSelection(range.index + 1);
    } catch (err) {
      console.error('Image upload failed:', err);
      alert('Upload failed');
    }
  };
}

const modules = {
  toolbar: {
    container: toolbarOptions,
    handlers: { image: imageHandler },
  }
};
const formats = [
  'header',
  'bold','italic','underline','strike',
  'list','bullet',
  'align',
  'link','image'
];
// ——————————————————————————————————

export default function BlogAdminDashboard({ user }) {
  const [posts,         setPosts]         = useState([]);
  const [loading,       setLoading]       = useState(true);

  // popup states
  const [popupContent,  setPopupContent]  = useState('');
  const [popupActive,   setPopupActive]   = useState(false);
  const [popupId,       setPopupId]       = useState(null);
  const BACKEND = process.env.REACT_APP_API_URL.replace(/\/api$/, '')


  const navigate = useNavigate();

   // derive the AdminJS control URL (change '/admincontrol' if you used a different rootPath)
  const apiRoot          = process.env.REACT_APP_API_URL.replace(/\/api$/, '');
  const adminControlUrl  = `${apiRoot}/admin`; // or `/admincontrol` if you mounted it there

  // redirect non‑admins
  useEffect(() => {
    if (!user || user.role !== 'admin') {
      navigate('/');
    } else {
      setLoading(false);
    }
  }, [user, navigate]);

  // fetch posts
  useEffect(() => {
    async function loadPosts() {
      try {
        const res  = await fetch(`${apiUrl}/api/posts?includeDrafts=true`);

        const data = await res.json();
        const list = Array.isArray(data)
          ? data
          : data.posts || data.data || [];
        setPosts(list);
      } catch (err) {
        console.error('Error fetching posts:', err);
        setPosts([]);
      }
    }
    loadPosts();
  }, []);

  // fetch popup settings
  useEffect(() => {
    async function loadPopup() {
      try {
        const res  = await axios.get(`${apiUrl}/api/blog/popup`);
        const d    = res.data || {};
        setPopupContent(d.content || '');
        setPopupActive(Boolean(d.isActive));
        setPopupId(d.id || null);
      } catch (err) {
        console.error('Error fetching popup:', err);
      }
    }
    loadPopup();
  }, []);

  // delete post
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this post?')) return;
    try {
      await fetch(`${apiUrl}/api/posts/${id}`, { method: 'DELETE' });

      const res  = await fetch(`${apiUrl}/blog/posts?includeDrafts=true`);
      const data = await res.json();
      setPosts(Array.isArray(data) ? data : data.posts || []);
    } catch (err) {
      console.error('Error deleting post:', err);
    }
  };

  // save popup (HTML comes from ReactQuill)
  const handlePopupSave = async () => {
    try {
      const payload = { content: popupContent, isActive: popupActive };
      if (popupId) {
        await axios.put(`${apiUrl}/blog/popup/${popupId}`, payload);
      } else {
        const res = await axios.post(`${apiUrl}/blog/popup`, payload);
        setPopupId(res.data.id);
      }
      alert('Popup saved successfully');
    } catch (err) {
      console.error('Error saving popup:', err);
      alert('Failed to save popup');
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="blog-custom-container">
      <h1>Admin Dashboard</h1>
      <Link to="/admin/new" className="blog-btn">
        + Create New Post
      </Link>
<button
  className="blog-btn"
  onClick={() => navigate('/admincontrol')}
>
  ⚙️ Open Admin Control
</button>




      {posts.length > 0 ? (
        posts.map(post => (
          <div key={post.id} className="blog-admin-post">
            <div>
              <h3>
                {post.title}
                {post.isDraft && <span className="draft-badge"> Draft</span>}
              </h3>
              <p>{post.category}</p>
            </div>
            <div>
              <Link to={`/admin/edit/${post.id}`} className="blog-btn">
                Edit
              </Link>
              <button
                className="blog-btn"
                onClick={() => handleDelete(post.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))
      ) : (
        <p>No posts found.</p>
      )}

      <hr />

      <h2>Popup Manager</h2>
      <label style={{ display: 'block', marginBottom: '0.5em' }}>
        <input
          type="checkbox"
          checked={popupActive}
          onChange={e => setPopupActive(e.target.checked)}
        />{' '}
        Enable Popup
      </label>

      <ReactQuill
        className="post-editor-quill"
        theme="snow"
        modules={modules}
        formats={formats}
        value={popupContent}
        onChange={setPopupContent}
      />

      <button className="blog-btn" onClick={handlePopupSave}>
        Save Popup
      </button>
    </div>
  );
}
